import script from "./MyCompanyForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyCompanyForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__